// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spacing-module__container--39mWo{padding-top:16px}\n", ""]);
// Exports
exports.locals = {
	"container": "spacing-module__container--39mWo"
};
module.exports = exports;
